import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { TID } from "@/constants/testIds/site";

const PACKS = [
  {
    id: "starter",
    name: "Starter",
    price: "2 000",
    unit: "CFA",
    tagline: "Pour poser les bases de votre marque.",
    features: [
      "Création Logo Professionnel",
      "1 révision incluse",
      "Livraison sous 48h",
      "Fichiers HD (PNG, PDF)",
    ],
    highlight: false,
  },
  {
    id: "growth",
    name: "Growth",
    price: "10 000",
    unit: "CFA",
    tagline: "Le combo Facebook idéal pour vendre.",
    features: [
      "Page Vente Facebook Pro",
      "500 abonnés qualifiés",
      "Bannière & photo de profil",
      "Guide de publication offert",
      "Support 7 jours",
    ],
    highlight: false,
  },
  {
    id: "empire",
    name: "Empire",
    price: "30 000",
    unit: "CFA",
    tagline: "Monétisation complète — 5 réseaux sociaux activés.",
    features: [
      "Ancien compte Afrique inclus",
      "Facebook · YouTube · Instagram",
      "Telegram · Snapchat",
      "Activation revenus immédiate",
      "Suivi premium 14 jours",
    ],
    highlight: true,
  },
];

export default function Pricing({ onOrder }) {
  return (
    <section
      id="pricing"
      data-testid={TID.pricing.section}
      className="relative py-28 md:py-36 px-6 md:px-10 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.4em] text-white/50 mb-4">
              <span className="dot-gold" />
              Nos packs signature
            </div>
            <h2 className="font-display text-5xl md:text-7xl tracking-tighter text-white leading-[0.95]">
              Choisissez votre <span className="text-gold-gradient italic">niveau</span>.
            </h2>
          </div>
          <p className="text-white/60 max-w-md">
            Trois formats, une promesse&nbsp;: chaque franc CFA investi
            travaille pour votre croissance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PACKS.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              data-testid={TID.pricing.card(p.id)}
              className={`relative rounded-2xl p-8 md:p-10 flex flex-col ${
                p.highlight
                  ? "gold-ring bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] md:scale-[1.03] md:-my-2"
                  : "border border-white/10 bg-[#111]"
              }`}
            >
              {p.highlight && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#d4af37] text-black text-[10px] uppercase tracking-[0.3em] px-3 py-1 rounded-full font-semibold">
                  Meilleur choix
                </span>
              )}
              <div className="flex items-center justify-between mb-6">
                <span className="font-display text-2xl text-white">
                  {p.name}
                </span>
                <span className="text-[10px] uppercase tracking-[0.35em] text-white/40">
                  Pack 0{i + 1}
                </span>
              </div>
              <div className="mb-6">
                <div className="flex items-baseline gap-2">
                  <span className="font-display text-6xl text-gold-gradient tracking-tighter">
                    {p.price}
                  </span>
                  <span className="text-white/60 text-sm">{p.unit}</span>
                </div>
                <div className="text-white/60 mt-3 text-sm leading-relaxed">
                  {p.tagline}
                </div>
              </div>

              <div className="line-x mb-6" />

              <ul className="space-y-3 mb-8 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-white/80 text-sm">
                    <Check
                      size={16}
                      className={p.highlight ? "text-[#d4af37]" : "text-white/50"}
                    />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <button
                data-testid={TID.pricing.orderBtn(p.id)}
                onClick={() => onOrder(`Pack ${p.name}`)}
                className={`w-full py-4 rounded-full text-sm font-semibold ${
                  p.highlight ? "btn-gold" : "btn-ghost"
                }`}
              >
                Commander ce pack
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
